import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import VideoUploader from './test';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store'; // Import the store
import { Provider } from 'react-redux'; // Import Provider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      {/* <VideoUploader /> */}
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();